<template>
  <div class="page-content d-flex flex-column">
    <Titlebar :incrustation="'fa-file'" :backPath="showBackBtn">
      <h1>{{ $t("reports.titles.list") }}</h1>
    </Titlebar>
    <div id="report-container" class="flex-1 relative d-flex flex-column">
      <div
        class="report-list-header px-3 d-flex align-items-center justify-content-between gap-1"
      >
        <UiButton
          :class="{
            selected: selectedReport,
            'btn-brand': selectorShow.report,
          }"
          @click.native.stop="showSelector('report')"
        >
          <div class="header-selector-inner truncate">
            <i class="fa fa-file mr-1"></i> {{ selectedReportLabel }}
          </div>
        </UiButton>
        <UiButton
          :class="{
            selected: selectedResource,
            'btn-brand': selectorShow.resource,
            disabled: !hasResourcesSelection,
          }"
          :disabled="!hasResourcesSelection"
          @click.native.stop="showSelector('resource')"
        >
          <div class="header-selector-inner truncate">
            <i class="fa fa-mobile-phone fa-lg mr-1"></i>
            {{ selectedResourceLabel }}
          </div>
        </UiButton>
        <UiButton
          :class="{
            selected: selectedPeriod.start.date,
            'btn-brand': selectorShow.period,
            disabled: !hasDateSelection,
          }"
          :disabled="!hasDateSelection"
          @click.native.stop="showSelector('period')"
        >
          <div class="header-selector-inner truncate">
            <i class="fa fa-calendar mr-1"></i> {{ selectedPeriodLabel }}
          </div>
        </UiButton>
        <UiButton
          class="primary"
          :class="{ disabled: !isAllSelected }"
          @click.native="showReport"
        >
          {{ $t("reports.btns.see") }}
        </UiButton>
      </div>
      <div class="relative">
        <div class="report-list-selector show" v-if="selectorShow.report">
          <div class="cards-container p-2">
            <div class="cards">
              <div
                class="card-item"
                v-for="report in reports"
                @click="selectReport(report, 'html')"
                :key="report.slug"
              >
                <div
                  class="card report-card"
                  :class="{
                    selected:
                      selectedReportId == report.id && canSelect(report.slug),
                    'licence-offer-difference':
                      (report.slug == 'ppes' && !canSelect(report.slug)) ||
                      (report.slug == 'actionpoint' && !canSelect(report.slug)),
                  }"
                >
                  <div class="d-flex">
                    <div class="icon text-center">
                      <i :class="report.icon"></i>
                    </div>
                    <div class="infos">
                      <h3>
                        {{ $t("reports.reports." + report.slug + ".title") }}
                      </h3>
                      <p>
                        {{
                          $t("reports.reports." + report.slug + ".description")
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="card-footer">
                    <span
                      class="badge"
                      v-for="output in report.output"
                      @click="selectReport(report, output)"
                      >{{ output }}</span
                    >
                    <span
                      style="float: right"
                      v-if="
                        (report.slug == 'ppes' && !canSelect(report.slug)) ||
                        (report.slug == 'actionpoint' &&
                          !canSelect(report.slug))
                      "
                    >
                      <i
                        class="fa fa-info-circle text-dark warning-beepiz-remote-monitoring show"
                      ></i>
                      <div
                        class="tooltip top"
                        style="width: 80%; right: 60px; top: 0px"
                      >
                        <h5 style="color: #ffc107; font-weight: 700">
                          {{
                            $t("reports.reports." + report.slug + ".infoTitle")
                          }}
                        </h5>
                        {{ $t("reports.reports." + report.slug + ".infoBody") }}
                      </div>
                      <i
                        class="fa fa-lock text-dark warning-beepiz-remote-monitoring show"
                        style="padding-left: 5px"
                      ></i>
                      <div
                        class="tooltip top"
                        style="width: 80%; right: 60px; top: 0px"
                      >
                        <h5 style="font-weight: 700">
                          Disponible à partir de l'offre Premium
                        </h5>
                        <span
                          style="
                            width: 45px;
                            height: 45px;
                            display: block;
                            text-align: center;
                          "
                          v-html="pictoPremium"
                        ></span>
                      </div>
                    </span>
                  </div>

                  <div class="select-marker">
                    <i class="fa fa-check"></i>
                  </div>
                </div>
              </div>

              <router-link
                :to="'/reports/platform?history=licence'"
                class="card-item"
              >
                <div class="card report-card">
                  <div class="icon text-center">
                    <i class="fa fa-newspaper-o"></i>
                  </div>
                  <div class="infos">
                    <h3>{{ $t("reports.reports.logs.title") }}</h3>
                    <p>{{ $t("reports.reports.logs.description") }}</p>
                  </div>
                  <div class="card-footer">
                    <span class="badge">XLS</span>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <div class="report-list-selector show" v-if="selectorShow.resource">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div
                  class="required-report"
                  v-show="!selectedReport"
                  v-html="$tc('reports.reportFirst')"
                ></div>
                <ResourceSelector
                  v-show="selectedReport"
                  :config="getSelectedReportResourcesConfig"
                  :preselected="getSelectedReportResourcesPreSelection"
                  @change="handleChangeResourcesSelection"
                ></ResourceSelector>
              </div>
            </div>
          </div>
        </div>
        <div class="report-list-selector show" v-if="selectorShow.period">
          <div class="container">
            <div class="row">
              <div class="col-12">
                <div
                  class="required-report"
                  v-show="!selectedReport"
                  v-html="$tc('reports.reportFirst')"
                ></div>
              </div>
              <div
                class="col-8 offset-2"
                style="text-align: center"
                v-show="selectedReport"
              >
                <span>{{ $t("global.fromToDate1") }}</span>
                <DatePicker
                  v-model="selectedPeriod.start.date"
                  :min="availablePeriod.start.date"
                  :max="availablePeriod.end.date"
                ></DatePicker>
                <ClockPicker v-model="selectedPeriod.start.time"></ClockPicker>
                <span>{{ $t("global.fromToDate2") }}</span>
                <DatePicker
                  v-model="selectedPeriod.end.date"
                  :min="availablePeriod.start.date"
                  :max="availablePeriod.end.date"
                ></DatePicker>
                <ClockPicker v-model="selectedPeriod.end.time"></ClockPicker>
                <br />
                <div class="duration-error" v-if="!isValidPeriod">
                  {{
                    $tc("reports.invalidPeriod", getSelectedNumberOfDays, {
                      count: getSelectedNumberOfDays,
                    })
                  }}
                </div>
              </div>
              <div class="col-2" v-show="selectedReport">
                <div class="flex flex-column">
                  <UiButton
                    v-if="isOneDay"
                    @click.native.stop="setDates('today')"
                    block
                  >
                    {{ $t("reports.shortLinks.today") }}
                  </UiButton>
                  <UiButton
                    v-if="isOneDay"
                    @click.native.stop="setDates('yesterday')"
                    block
                  >
                    {{ $t("reports.shortLinks.yesterday") }}
                  </UiButton>
                  <UiButton
                    v-if="isOneWeek"
                    @click.native.stop="setDates('thisweek')"
                    block
                  >
                    {{ $t("reports.shortLinks.thisweek") }}
                  </UiButton>
                  <UiButton
                    v-if="isOneWeek"
                    @click.native.stop="setDates('lastweek')"
                    block
                  >
                    {{ $t("reports.shortLinks.lastweek") }}
                  </UiButton>
                  <UiButton
                    v-if="isOneMonth"
                    @click.native.stop="setDates('thismonth')"
                    block
                  >
                    {{ $t("reports.shortLinks.thismonth") }}
                  </UiButton>
                  <UiButton
                    v-if="isOneMonth"
                    @click.native.stop="setDates('lastmonth')"
                    block
                  >
                    {{ $t("reports.shortLinks.lastmonth") }}
                  </UiButton>
                  <UiButton
                    v-if="isOneMonth"
                    @click.native.stop="setDates('last30days')"
                    block
                  >
                    {{ $t("reports.shortLinks.last30days") }}
                  </UiButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="report-placeholder flex-1" v-show="!result">
        <h2>{{ $t("reports.placeholder.first") }}</h2>
        <p>
          {{ $t("reports.placeholder.second") }}<br />
          <span
            @click="showSelector('report')"
            v-html="$t('reports.placeholder.report')"
          ></span
          >,
          <span
            @click="showSelector('resource')"
            v-html="$t('reports.placeholder.resource')"
          ></span>
          {{ $t("global.and") }}
          <span
            @click="showSelector('period')"
            v-html="$t('reports.placeholder.period')"
          ></span
          >.
        </p>
      </div>
      <iframe ref="reportResult" v-show="result" class="flex-1 border"></iframe>
      <div class="absolute right-3 bottom-3">
        <Btn
          v-if="
            selectedReportOutputs.length > 1 &&
            useDvFlagAccess('beepiz-report-can:export')
          "
          :class="[
            {
              'no-hover': showActionsDL,
              disabled: !isAllSelected || lockDLBtn,
            },
            'default',
          ]"
          @click.native.prevent="toggleActionsDL"
        >
          <div
            class="button-actions"
            :class="{ show: showActionsDL }"
            v-on-clickaway="closeActionsDL"
          >
            <ul>
              <li
                v-for="output in selectedReportOutputs"
                @click.stop="dlReport(output)"
              >
                {{ output | uppercase }}
              </li>
            </ul>
          </div>
          <i class="fa fa-caret-up"></i>
          <span
            ><i class="fa fa-download"></i>&nbsp;&nbsp;&nbsp;{{
              $t("global.download")
            }}</span
          >
          <LoadingMini ref="loading"></LoadingMini>
        </Btn>
        <Btn
          v-if="
            selectedReportOutputs.length == 1 &&
            useDvFlagAccess('beepiz-report-can:export')
          "
          class="default pull-left"
          :class="{ disabled: !isAllSelected || lockDLBtn }"
          @click.native="dlReport(selectedReportOutputs[0])"
          ><i class="fa fa-download"></i>&nbsp;&nbsp;&nbsp;{{
            $t("global.download")
          }}
          <LoadingMini ref="loading"></LoadingMini>
        </Btn>
      </div>
    </div>
  </div>
</template>

<script>
import find from "lodash/find";
import axios from "axios";
import API from "@/services/API.js";
import Globals from "@/services/globals.js";
import Utils from "@/services/utils.js";
import Auth from "@/services/auth.js";
import report from "@/services/report.js";
import Titlebar from "@/components/ui/Titlebar";
import Toolbar from "@/components/ui/Toolbar";
import Btn from "@/components/ui/Button";
import UiButton from "@/components/ui/Button2";
import UiCard from "@/components/ui/Card";
import Vue from "vue";
import moment from "moment";
import VInputmask from "v-inputmask";

import ResourceSelector from "@/components/reports/ResourceSelector";

import ClockPicker from "@/components/ui/datetime/TimePicker";
import DatePicker from "@/components/ui/datetime/DatePicker";

import AlertModal from "@/components/alert/AlertModal";

import LoadingMini from "@/components/ui/LoadingMini";

import { mixin as clickaway } from "vue-clickaway";
import picto_premium from "@/assets/img/picto/2_Premium_yellow.svg";

import _findIndex from "lodash/findIndex";
import { useDvFlag, useDvFlagAccess } from "../../services/featureFlag";

Vue.use(VInputmask);

export default {
  beforeRouteUpdate(to, from, next) {
    if (to.params.reportName == "usage" && from.params.reportName == "usage") {
      next();
    } else if (
      to.params.reportName == "ppes" &&
      from.params.reportName == "ppes"
    ) {
      next();
    } else {
      window.Vfc.$refs.loading.show(() => {
        if (
          to.params.reportName == "activity" &&
          from.params.reportName == "usage"
        ) {
          this.showBackBtn = true;
          this.autoLoad = true;
        } else if (
          to.params.reportName == "activity" &&
          from.params.reportName == "ppes"
        ) {
          this.showBackBtn = true;
          this.autoLoad = true;
        } else if (
          to.params.reportName == "usage" &&
          from.params.reportName == "activity"
        ) {
          this.showBackBtn = false;
          this.autoLoad = true;
        } else if (
          to.params.reportName == "ppes" &&
          from.params.reportName == "activity"
        ) {
          this.showBackBtn = false;
          this.autoLoad = true;
        } else {
          this.showBackBtn = false;
        }

        next();

        this.refreshFromParams();
      });
    }
  },
  components: {
    Titlebar,
    Toolbar,
    Btn,
    UiButton,
    UiCard,
    ResourceSelector,
    ClockPicker,
    DatePicker,
    LoadingMini,
  },
  mixins: [clickaway],
  computed: {
    pictoPremium() {
      return picto_premium;
    },
    isAllSelected: function () {
      if (this.selectedReport) {
        if (this.selectedReport.ressources === false) {
          if (this.selectedReport.date === false) {
            return true;
          } else {
            return this.isValidPeriod;
          }
        } else {
          if (this.selectedReport.date === false) {
            return !!this.selectedResource;
          } else {
            return !!(this.selectedResource && this.isValidPeriod);
          }
        }
      }

      return false;
    },
    selectedReportId: function () {
      if (this.selectedReport) {
        return this.selectedReport.id;
      }
      return 0;
    },
    getSelectedReportResourcesConfig: function () {
      if (this.selectedReport) {
        let resources = this.selectedReport.ressources;

        // Si le flag est false, on supprime la ressource
        if (!useDvFlagAccess("beepiz-licence-can:read")) {
          resources = Utils.reportResourceSpliceKey(resources, "dati");
        }

        if (!useDvFlagAccess("beepiz-identifications-can:read")) {
          resources = Utils.reportResourceSpliceKey(
            resources,
            "identification",
          );
        }

        return resources;
      }
      return {};
    },
    selectedReportLabel: function () {
      if (this.selectedReport) {
        return Utils.t(
          "reports.reports." + this.selectedReport.slug + ".title",
        );
      }
      return Utils.t("reports.selectors.report");
    },
    selectedReportOutputs: function () {
      if (this.selectedReport) {
        return this.selectedReport.output;
      }
      return [];
    },
    selectedResourceLabel: function () {
      if (this.selectedResource && this.selectedResource.length > 0) {
        if (this.selectedResource.length > 1) {
          return Utils.tc(
            "reports.selectors.multipleresource",
            this.selectedResource.length,
            { count: this.selectedResource.length },
          );
        } else {
          return this.selectedResource[0].name;
        }
      }
      return Utils.t("reports.selectors.resource");
    },
    selectedPeriodLabel: function () {
      if (this.selectedPeriod) {
        return (
          this.selectedPeriod.start.date.format(Utils.t("datetime.date")) +
          " " +
          this.selectedPeriod.start.time +
          " - " +
          this.selectedPeriod.end.date.format(Utils.t("datetime.date")) +
          " " +
          this.selectedPeriod.end.time
        );
      }
      return Utils.t("reports.selectors.period");
    },
    isOneDay: function () {
      if (this.selectedReport != null) {
        return true;
      }
      return false;
    },
    isOneWeek: function () {
      if (this.selectedReport != null && this.selectedReport.date.day > 1) {
        return true;
      }
      return false;
    },
    isOneMonth: function () {
      if (this.selectedReport != null && this.selectedReport.date.day > 7) {
        return true;
      }
      return false;
    },
    getSelectedNumberOfDays: function () {
      if (this.selectedReport) {
        return this.selectedReport.date.day;
      }
      return 1;
    },
    isValidPeriod: function () {
      var tempS = this.selectedPeriod.start.time.split(":");
      var start = moment(this.selectedPeriod.start.date)
        .hour(tempS[0])
        .minute(tempS[1]);

      var tempE = this.selectedPeriod.end.time.split(":");
      var end = moment(this.selectedPeriod.end.date)
        .hour(tempE[0])
        .minute(tempE[1]);

      if (
        this.selectedReport != null &&
        end.diff(start, "minutes") > this.selectedReport.date.day * 1440 + 59
      ) {
        return false;
      }

      return true;
    },
    constructRoute: function () {
      var route = "/reports";
      if (this.selectedReport) {
        route += "/" + this.selectedReport.slug;

        if (this.selectedResource) {
          route += "/" + this.selectedResourceType + "-";
          for (var rKey in this.selectedResource) {
            route += this.selectedResource[rKey].id + ",";
          }
          route = route.substring(0, route.length - 1);

          if (this.selectedPeriod) {
            route +=
              "/" +
              this.selectedPeriod.start.date.format("YYYY-MM-DD") +
              "%20" +
              this.selectedPeriod.start.time +
              "_" +
              this.selectedPeriod.end.date.format("YYYY-MM-DD") +
              "%20" +
              this.selectedPeriod.end.time;
          }
        }
      }

      return route;
    },

    getSelectedReportResourcesPreSelection: function () {
      var params = this.$route.params;

      if (params.reportResources) {
        return this.handleResourceRouteSegment(params.reportResources);
      }
      return null;
    },

    constructReportFileName: function () {
      var name = Utils.t(
        "reports.reports." + this.selectedReport.slug + ".title",
      );

      if (this.selectedReport.date !== false) {
        name +=
          " " +
          Utils.t("global.fromToDate1") +
          " " +
          this.selectedPeriod.start.date.format(
            Utils.t("datetime.reportDate"),
          ) +
          "-" +
          this.selectedPeriod.start.time +
          " " +
          Utils.t("global.fromToDate2") +
          " " +
          this.selectedPeriod.end.date.format(Utils.t("datetime.reportDate")) +
          "-" +
          this.selectedPeriod.end.time;
      } else {
        name += " " + moment().format(Utils.t("datetime.reportDate"));
      }

      if (this.selectedReport.ressources !== false) {
        name += "-" + this.selectedResourceLabel;
      }

      return Utils.sanitize(name, true);
    },

    hasPpesAccess() {
      return useDvFlagAccess("beepiz-ppe-v2-can:read");
    },

    hasActionpointAccess() {
      return useDvFlagAccess("beepiz-action-point-can:read");
    },

    hasResourcesSelection() {
      if (this.selectedReport) {
        if (this.selectedReport.ressources === false) {
          return false;
        }
      }
      return true;
    },

    hasDateSelection() {
      if (this.selectedReport) {
        if (this.selectedReport.date === false) {
          return false;
        }
      }
      return true;
    },
  },
  created: function () {},
  data() {
    return {
      selectedReport: null,
      selectedReportOutput: "html",
      selectedResource: null,
      selectedResourceType: null,
      selectedPeriod: {
        start: {
          date: moment().subtract(1, "days"),
          time: moment().format("HH:mm"),
        },
        end: {
          date: moment(),
          time: moment().format("HH:mm"),
        },
      },
      availablePeriod: {
        start: {
          date: null,
          time: null,
        },
        end: {
          date: null,
          time: null,
        },
      },
      selectorShow: {
        report: true,
        resource: false,
        period: false,
      },
      reports: [],
      picker: null,
      testTime: "08:30",
      testDate: moment("2017-04-26"),
      testMinDate: moment("2017-04-27"),
      result: false,
      autoLoad: false,
      showActionsDL: false,
      dlFirstTime: true,
      showBackBtn: false,
      lockDLBtn: false,
      timezone: moment.tz.guess(),
    };
  },
  destroyed: function () {},
  methods: {
    useDvFlagAccess,
    useDvFlag,
    canSelect: function (slug) {
      if (slug === "ppes") {
        return useDvFlagAccess("beepiz-ppe-v2-can:read");
      }
      if (slug === "actionpoint") {
        return useDvFlagAccess("beepiz-action-point-can:read");
      }
      return true;
    },
    selectReport(report, output) {
      if (this.canSelect(report.slug)) {
        this.selectedReport = report;
        this.selectedReportOutput = output;
        this.selectedResource = null;
        this.selectedResourceType = null;
        //window.V.router.push()
        this.calculateMinMaxDate();
        this.calculateDefaultDate();
      }
    },
    showSelector(type) {
      if (type != "report") {
        this.selectorShow.report = false;
      }
      if (type != "resource") {
        this.selectorShow.resource = false;
      }
      if (type != "period") {
        this.selectorShow.period = false;
      }

      this.selectorShow[type] = !this.selectorShow[type];
    },
    loadData() {
      var axiosCustom = axios.create({
        baseURL: "/json/",
      });

      axiosCustom
        .get(API.endpoints.reports.index + "?cb=" + moment().format("X"))
        .then((response) => {
          this.reports = response.data;

          var params = this.$route.params;
          if (params.reportName) {
            this.selectedReport = this.getReportBySlug(params.reportName);

            if (
              params.reportName == "actionpoint" ||
              params.reportName == "activity"
            ) {
              this.selectedResourceType =
                this.getSelectedReportResourcesPreSelection.type;
              Vue.set(this, "selectedResource", null);
              Vue.set(
                this,
                "selectedResource",
                this.getSelectedReportResourcesPreSelection.values.map(
                  (id) => ({ id }),
                ),
              );
              this.showReport();
            }
          }
        });
    },
    handleChangeResourcesSelection(data) {
      this.selectedResourceType = data.type;
      Vue.set(this, "selectedResource", null);
      Vue.set(this, "selectedResource", data.values);
      if (this.autoLoad) {
        this.autoLoad = false;
        this.showReport();
      }
    },
    calculateMinMaxDate() {
      this.availablePeriod.end.date = moment();
      this.availablePeriod.end.time = "23:59";

      this.availablePeriod.start.date = moment().subtract(380, "days");
      this.availablePeriod.start.time = "00:00";
    },
    calculateDefaultDate() {
      this.selectedPeriod = {
        start: {
          date: moment().subtract(this.selectedReport.date.day, "days"),
          time: moment().format("HH:mm"),
        },
        end: {
          date: moment(),
          time: moment().subtract(1, "minutes").format("HH:mm"),
        },
      };
    },
    setDates: function (tag) {
      switch (tag) {
        case "today":
          this.selectedPeriod.start.date = moment();
          this.selectedPeriod.start.time = "00:00";
          this.selectedPeriod.end.date = moment();
          this.selectedPeriod.end.time = moment().format("HH:mm");
          break;
        case "yesterday":
          this.selectedPeriod.start.date = moment().subtract(1, "days");
          this.selectedPeriod.start.time = "00:00";
          this.selectedPeriod.end.date = moment().subtract(1, "days");
          this.selectedPeriod.end.time = "23:59";
          break;
        case "thisweek":
          this.selectedPeriod.start.date = moment().startOf("week");
          this.selectedPeriod.start.time = "00:00";
          this.selectedPeriod.end.date = moment();
          this.selectedPeriod.end.time = moment().format("HH:mm");
          break;
        case "lastweek":
          this.selectedPeriod.start.date = moment()
            .startOf("week")
            .subtract(7, "days");
          this.selectedPeriod.start.time = "00:00";
          this.selectedPeriod.end.date = moment()
            .endOf("week")
            .subtract(7, "days");
          this.selectedPeriod.end.time = "23:59";
          break;
        case "thismonth":
          this.selectedPeriod.start.date = moment().startOf("month");
          this.selectedPeriod.start.time = "00:00";
          this.selectedPeriod.end.date = moment();
          this.selectedPeriod.end.time = moment().format("HH:mm");
          break;
        case "lastmonth":
          this.selectedPeriod.start.date = moment()
            .subtract(1, "month")
            .startOf("month");
          this.selectedPeriod.start.time = "00:00";
          this.selectedPeriod.end.date = moment()
            .subtract(1, "month")
            .endOf("month");
          this.selectedPeriod.end.time = "23:59";
          break;
        case "last30days":
          this.selectedPeriod.start.date = moment().subtract(30, "days");
          this.selectedPeriod.start.time = "00:00";
          this.selectedPeriod.end.date = moment();
          this.selectedPeriod.end.time = moment().format("HH:mm");
          break;
      }
    },
    getReportBySlug(slug) {
      return find(this.reports, { slug: slug });
    },
    handleResourceRouteSegment(routeSegment) {
      var temp = routeSegment.split("-");
      var ids = temp[1].split(",");
      return { type: temp[0], values: ids };
    },

    showReport: function () {
      //location.hash = '#' + this.constructRoute;
      window.Vfc.$refs.loading.show();

      var vThis = this;

      var route = API.endpoints.reports[this.selectedReport.slug];

      var start = moment(
        this.selectedPeriod.start.date.format("YYYY-MM-DD") +
          " " +
          this.selectedPeriod.start.time +
          ":00",
      )
        .tz("Europe/Paris")
        .format("YYYY-MM-DD HH:mm:ss");
      var end = moment(
        this.selectedPeriod.end.date.format("YYYY-MM-DD") +
          " " +
          this.selectedPeriod.end.time +
          ":59",
      )
        .tz("Europe/Paris")
        .format("YYYY-MM-DD HH:mm:ss");

      var params = {
        resourceType:
          this.selectedReport.ressources === false
            ? "resource"
            : this.selectedResourceType,
        resourceId:
          this.selectedReport.ressources === false
            ? "1"
            : this.selectedResource.map((elmt) => elmt.id).join(","),
        reportPeriod:
          this.selectedReport.date === false
            ? moment().subtract(1, "day").format("YYYY-MM-DD") +
              " 00:00:00," +
              moment().subtract(1, "day").format("YYYY-MM-DD") +
              " 23:59:59"
            : start + "," + end,
      };

      var filteredSlug =
        this.selectedReport.slug === "alerts"
          ? "alert"
          : this.selectedReport.slug;

      axios
        .post(
          "/beepiz/reports",
          {
            reportSlug: filteredSlug,
            resourceType: params.resourceType + "-" + params.resourceId,
            dates: params.reportPeriod,
            timezone: this.timezone,
          },
          {
            headers: {
              Accept: "text/html",
              "Content-Type": "application/json",
            },
          },
        )
        .then((response) => {
          this.result = true;
          this.selectorShow.report = false;
          this.selectorShow.resource = false;
          this.selectorShow.period = false;

          var doc = this.$refs.reportResult.contentWindow.document;
          doc.open();
          doc.write(response.data);
          doc.close();

          switch (this.selectedReport.slug) {
            case "activity":
            case "alerts":
              if (useDvFlagAccess("beepiz-report-can:read")) {
                var alerts = doc.getElementsByClassName("category-1");

                Array.from(alerts).forEach(function (element) {
                  element.addEventListener("click", function () {
                    var alerturl = this.getAttribute("data-alerturl");
                    var alertid = this.getAttribute("data-alertid");
                    var alertack = this.getAttribute("data-alertack");
                    var alertdate = this.getAttribute("data-alertdate");
                    window.Vfc.modalProps = {
                      title: "Visualiser une alerte",
                      width: "1000px",
                      height: "100%",
                      type: "danger",
                    };
                    window.Vfc.modalComponentProps = {
                      url: alerturl,
                      id: alertid,
                      ack: alertack,
                      eventAt: alertdate,
                      dismissCallback: () => {
                        vThis.showReport();
                      },
                    };
                    window.Vfc.modalComponent = AlertModal;
                    window.Vfc.blurMode(true);
                    window.Vfc.$refs.modal.show(() => {});
                  });

                  element.querySelector(".event-infos").innerHTML +=
                    '<div class="alert-record-report-btn" title="' +
                    Utils.t("reports.reports.alertRecord.tooltip") +
                    '"><i class="fa fa-file-text"></i><i class="fa fa-spinner fa-spin fa-hidden"></i></div>';
                  element
                    .querySelector(".event-infos .alert-record-report-btn")
                    .addEventListener("click", (evt) => {
                      evt.stopPropagation();
                      element
                        .querySelector(
                          ".event-infos .alert-record-report-btn .fa-file-text",
                        )
                        .classList.add("fa-hidden");
                      element
                        .querySelector(
                          ".event-infos .alert-record-report-btn .fa-spin",
                        )
                        .classList.remove("fa-hidden");
                      report
                        .dlAlertRecord(
                          element.getAttribute("data-alertid"),
                          Utils.t("reports.reports.alertRecord.title") +
                            " " +
                            Utils.alertNumberFormated(
                              element.getAttribute("data-alertid"),
                            ) +
                            " " +
                            Utils.t("global.fromToDate1") +
                            " " +
                            moment(
                              element.getAttribute("data-alertdate"),
                            ).format(
                              Utils.t("datetime.reportDateTimeComplete"),
                            ),
                        )
                        .then(() => {
                          element
                            .querySelector(
                              ".event-infos .alert-record-report-btn .fa-spin",
                            )
                            .classList.add("fa-hidden");
                          element
                            .querySelector(
                              ".event-infos .alert-record-report-btn .fa-file-text",
                            )
                            .classList.remove("fa-hidden");
                        });
                    });
                });
              }
              break;
            case "usage":
            case "ppes":
              var activeDays = doc.querySelectorAll(
                ".report-content > table > tbody > tr > td > span",
              );

              Array.from(activeDays).forEach(function (element) {
                element.addEventListener("click", function () {
                  this.autoLoad = true;

                  var datiId = this.getAttribute("data-dati-id");
                  var dateReport = this.getAttribute("data-date");

                  window.V._router.push({
                    path:
                      "/reports/activity/dati-" +
                      datiId +
                      "/" +
                      dateReport +
                      " 00:00_" +
                      dateReport +
                      " 23:59",
                  });
                });
              });
              break;
          }

          setTimeout(() => {
            window.Vfc.$refs.loading.hide();
          }, 1000);
        })
        .catch((error) => {
          if (error.response.status == 422) {
            window.Vfc.$refs.messages.sendMessage(
              "error",
              window.V.$i18n.t("errors.e422") +
                " " +
                error.response.data.start[0],
            );
            window.Vfc.$refs.loading.hide();
          }
        });
    },

    dlReport: function (outputFormat) {
      if (!this.lockDLBtn) {
        this.$refs.loading.show();
        this.lockDLBtn = true;
        this.closeActionsDL();

        var route = API.endpoints.reports[this.selectedReport.slug];

        var start = moment(
          this.selectedPeriod.start.date.format("YYYY-MM-DD") +
            " " +
            this.selectedPeriod.start.time +
            ":00",
        )
          .tz("Europe/Paris")
          .format("YYYY-MM-DD HH:mm:ss");
        var end = moment(
          this.selectedPeriod.end.date.format("YYYY-MM-DD") +
            " " +
            this.selectedPeriod.end.time +
            ":59",
        )
          .tz("Europe/Paris")
          .format("YYYY-MM-DD HH:mm:ss");

        var params = {
          resourceType:
            this.selectedReport.ressources === false
              ? "resource"
              : this.selectedResourceType,
          resourceId:
            this.selectedReport.ressources === false
              ? "1"
              : this.selectedResource.map((elmt) => elmt.id).join(","),
          reportPeriod:
            this.selectedReport.date === false
              ? moment().subtract(1, "day").format("YYYY-MM-DD") +
                " 00:00:00," +
                moment().subtract(1, "day").format("YYYY-MM-DD") +
                " 23:59:59"
              : start + "," + end,
        };

        var filteredSlug =
          this.selectedReport.slug === "alerts"
            ? "alert"
            : this.selectedReport.slug;

        axios({
          method: "post",
          url: "/beepiz/reports",
          responseType: "blob",
          data: {
            reportSlug: filteredSlug,
            resourceType: params.resourceType + "-" + params.resourceId,
            dates: params.reportPeriod,
            timezone: this.timezone,
          },
          headers: {
            Accept: Utils.getMimeFromOutput(outputFormat),
          },
        })
          .then((response) => {
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            var newBlob = new Blob([response.data], {
              type: Utils.getMimeFromOutput(outputFormat),
            });

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(
                newBlob,
                this.constructReportFileName + "." + outputFormat,
              );
              return;
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement("a");
            document.body.appendChild(link);
            link.href = data;
            link.download = this.constructReportFileName + "." + outputFormat;
            link.click();
            setTimeout(function () {
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(data);
            }, 100);
            this.$refs.loading.hide();
            this.lockDLBtn = false;
          })
          .catch((error) => {
            this.$refs.loading.hide();
            this.lockDLBtn = false;

            if (error.response) {
              if (error.response.status == 422) {
                window.Vfc.$refs.messages.sendMessage(
                  "error",
                  window.V.$i18n.t("errors.e422") +
                    " " +
                    error.response.data.message,
                );
              }
            } else {
              window.Vfc.$refs.messages.sendMessage(
                "error",
                window.V.$i18n.t("errors.e500") + " " + error,
              );
            }
          });
      }
    },

    toggleActionsDL: function () {
      this.showActionsDL = !this.showActionsDL;
    },
    closeActionsDL: function () {
      if (this.showActionsDL && !this.dlFirstTime) {
        this.showActionsDL = false;
        this.dlFirstTime = true;
      } else {
        this.dlFirstTime = false;
      }
    },

    refreshFromParams() {
      var params = this.$route.params;
      if (params.reportName && params.reportResources && params.reportPeriod) {
        var period = params.reportPeriod.split("_");
        var start = period[0];
        var end = period[1];

        this.selectedPeriod = {
          start: {
            date: moment(start),
            time: moment(start).format("HH:mm"),
          },
          end: {
            date: moment(end),
            time: moment(end).format("HH:mm"),
          },
        };
        //this.autoLoad = true;
      } else if (params.reportName == "actionpoint") {
      } else {
        window.Vfc.$refs.loading.hide();
      }

      this.loadData();

      //window.Vfc.$refs.loading.hide();
    },
  },
  mounted: function () {
    if (!useDvFlagAccess("beepiz-report-can:read")) {
      this.$router.push({ name: "AccessDenied", params: { slug: "reports" } });
    } else {
      var params = this.$route.params;
      if (
        (params.reportName && params.reportResources && params.reportPeriod) ||
        params.reportName == "actionpoint"
      ) {
        this.autoLoad = true;
      }
      this.refreshFromParams();
    }
  },
  name: "ReportsList",
};
</script>
